import { useEffect, useState, type RefObject } from 'react';

/** Measure the plot strip so ticks and markers can share the same pixel width. */
export function useTimelinePlotWidth(
  plotRef: RefObject<HTMLElement | null>,
): number {
  const [plotWidth, setPlotWidth] = useState(0);

  useEffect(() => {
    const plot = plotRef.current;
    if (!plot) {
      return undefined;
    }

    const updateWidth = () => {
      setPlotWidth(plot.getBoundingClientRect().width);
    };
    updateWidth();

    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width ?? 0;
      setPlotWidth(width);
    });
    observer.observe(plot);
    return () => observer.disconnect();
  }, [plotRef]);

  return plotWidth;
}
